// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationModal-cls1__cdfd186b12ccfd0efe1d","cls2":"ConfirmationModal-cls2__a12ee8cd0f9632ac24d2 ConfirmationModal-cls1__cdfd186b12ccfd0efe1d"};